import React, { useEffect } from "react";
import { trackShowPhoneWall, WALL_TYPES } from "analytics/sms";
import { LANDING_SCREEN_VARIANTS } from "shared/components/SmsMigrationModal/constants";
import SmsMigrationModal from "shared/components/SmsMigrationModal";
import useSmsWall from "../hooks/useSmsWall";

const SmsConvoWall = () => {
	const {
		showPhoneWall,
		showPhoneVerification,
		closePhoneVerification,
		closePhoneVerificationAndRefetch,
	} = useSmsWall();

	const show = showPhoneWall && showPhoneVerification;

	useEffect(() => {
		if (show) {
			trackShowPhoneWall(WALL_TYPES.CONVO_WALL);
		}
	}, [show]);

	return show && (
		<SmsMigrationModal
			show={showPhoneVerification}
			onCancel={closePhoneVerification}
			handleSuccess={closePhoneVerificationAndRefetch}
			landingScreenVariant={LANDING_SCREEN_VARIANTS.VERIFY}
		/>
	);
};

export default SmsConvoWall;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/SmsConvoWall.jsx